import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IApiModel } from '../models/api.model';
import { environment } from '../../../environments/environment';

@Injectable()
export class SettingsService {
  constructor(private http: HttpClient) {
  }

  updateSignature(
    idAccount: number,
    signature: string,
    updateCampaigns: boolean = false
  ): Observable<IApiModel> {
    return this.http.put<IApiModel>(
      environment.apiUrl + `/v1/settings/${idAccount}`,
      {
        signature,
        update_campaigns: updateCampaigns
      },
    );
  }
}
